<ori-dialog-content2 (close)="close()" class="flex flex-col gap-0 p-0 sm:max-h-[min(640px,80vh)] sm:max-w-xl [&>button:last-child]:top-3.5" >
        <ori-dialog-header class="contents space-y-0 text-left">
          <ori-dialog-title class="border-border border-b px-6 py-4 text-base">
            {{title}}
          </ori-dialog-title>
          <div class="overflow-y-auto select-none"  >
            <ori-dialog-description>
              <div class="px-6 py-4">
                <div class="[&_strong]:text-foreground space-y-4 [&_strong]:font-semibold">

                  <div class="space-y-4">
                      <div class="space-y-1">
                          <div
                            class="border border-secondary rounded p-4 text-center cursor-pointer mb-3"
                            (dragover)="onDragOver($event)"
                            (drop)="onFileDrop($event)"
                            style="background-color: #f9f9f9;"
                          >
                            <p class="mb-4 ">Drag & Drop your file here or click to select</p>
                              <input type="file" (change)="onFileSelect($event)" #fileInput hidden  accept=".xls,.xlsx"/>
                              <div class="flex justify-center items-center gap-2 flex-wrap">
                                <input type="text" class="flex-1 min-w-[80px] max-w-[600px] px-3 py-2 border border-gray-300 rounded bg-white" [value]="fileName" readonly style="width: 600px;"  />
                                <button oriButton variant="noHover" type="button" class="button-primary min-w-[80px] px-4 py-2 border border-gray-300 bg-gray-100 rounded hover:bg-gray200 active:scale-95 transition" (click)="fileInput.click()" appRipple>Choose File</button>
                              </div>

                          </div>

                        <p class="flex flex-row">
                            <strong>Notes</strong>
                        </p>
                        <p>
                          <textarea
                            rows="1"
                            class="min-h-[42px] focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 border border-gray-400 w-full rounded-sm text-base leading-6 text-black px-3 py-2"
                            oriTextarea [(ngModel)]="notes">
                          </textarea>

                        </p>

                        <p class="flex flex-row">
                            <strong>List of invoices to be included in the zip file</strong>
                        </p>
                        <p>
                          <textarea class="min-h-[none] focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 border border-gray-400 w-full rounded-sm" oriTextarea [value]="invoiceText"
                          rows="4"  readonly tabindex="-1" onmousedown="return false;" onfocus="this.blur();" style="font-family: monospace; white-space: pre;"
                          ></textarea>
                        </p>
                          
                      </div>
                  </div>
                </div>
              </div>
            </ori-dialog-description>
          </div>
        </ori-dialog-header>
        <ori-dialog-footer class="border-border border-t px-6 py-4 sm:items-center">
          <button oriButton type="button" variant="outline" class="" (click)="close()" >Close</button>
          <button   oriButton variant="noHover" (click)="generateZip()" [disabled]="isGenerating" type="button" class="button-primary select-none" appRipple >Generate Zip</button>
        </ori-dialog-footer>
      </ori-dialog-content2>
  <!-- Loading Spinner -->
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>